import styled from 'styled-components';
import {BGImageCenter} from '../../../globalVariables/GlobalVariables';
import {op} from '../../../assets/symbols/symbols/Symbols.css';

export const optionsIcon = styled.div`
    width: 30px;
    height: 30px;
    ${BGImageCenter(op, '12px')}
    cursor: pointer;
`;